module.exports = __webpack_public_path__ + "static/media/seller-signup.03bb63c6.jpg";